/* eslint-disable func-names */
/* eslint-disable no-extend-native */
String.prototype.data = function (...values) {
  return this.replace(/\{([0-9]+)\}/g, (_, index) => values[index]);
};

String.prototype.turkishtoEnglish = function () {
  return this.replace(/Ğ/gim, 'g')
    .replace(/Ü/gim, 'u')
    .replace(/Ş/gim, 's')
    .replace(/I/gim, 'i')
    .replace(/İ/gim, 'i')
    .replace(/Ö/gim, 'o')
    .replace(/Ç/gim, 'c')
    .replace(/ğ/gim, 'g')
    .replace(/ü/gim, 'u')
    .replace(/ş/gim, 's')
    .replace(/ı/gim, 'i')
    .replace(/ö/gim, 'o')
    .replace(/ç/gim, 'c');
};
